import { RadioGroup as MuiRadioGroup, RadioGroupProps } from "@mui/material";

type Props = RadioGroupProps;

export const RadioGroup = ({ children, ...props }: Props) => {
  return <MuiRadioGroup {...props}>{children}</MuiRadioGroup>;
};
